var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "discrete-query-wizard" },
    [
      _c(
        "nav",
        {
          staticClass: "wizard-nav",
          attrs: { "aria-label": "Query workflow" },
        },
        _vm._l(_vm.stepNavItems, function (step) {
          return _c(
            "v-btn",
            {
              key: step.id,
              class: {
                "wizard-nav-current": _vm.activeStep === step.id,
                "wizard-nav-done": _vm.isStepComplete(step.id),
              },
              attrs: { flat: "", disabled: !_vm.canNavigateTo(step.id) },
              on: {
                click: function ($event) {
                  return _vm.goToStep(step.id)
                },
              },
            },
            [
              _c("span", { staticClass: "wizard-nav-index" }, [
                _vm._v(_vm._s(_vm.isStepComplete(step.id) ? "✓" : step.id)),
              ]),
              _vm._v(" "),
              _c("v-icon", { attrs: { small: "" } }, [
                _vm._v(_vm._s(step.icon)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "wizard-nav-label" }, [
                _vm._v(_vm._s(step.label)),
              ]),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "state-banner",
          class: { "state-banner-pending": !_vm.canSubmit },
          attrs: { role: "status", "aria-live": "polite" },
        },
        [
          _c("span", { staticClass: "state-mark" }, [
            _vm._v(_vm._s(_vm.canSubmit ? "✓" : "!")),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "state-title" }, [
              _vm._v(_vm._s(_vm.stateBannerTitle)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "state-copy" }, [
              _vm._v(_vm._s(_vm.stateBannerCopy)),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.initializationError
        ? _c(
            "v-alert",
            { attrs: { value: true, type: "error", outline: "" } },
            [_vm._v("\n    " + _vm._s(_vm.initializationError) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.errorMessage
        ? _c(
            "v-alert",
            {
              attrs: {
                value: true,
                type: "error",
                outline: "",
                dismissible: "",
              },
              on: {
                input: function ($event) {
                  _vm.errorMessage = ""
                },
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isDirty
        ? _c(
            "v-alert",
            { attrs: { value: true, type: "warning", outline: "" } },
            [_vm._v("\n    " + _vm._s(_vm.statusMessage) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "wizard-step",
          class: { "step-completed": _vm.steps.scope },
          attrs: { id: "query-step-1", flat: "" },
        },
        [
          _c("div", { staticClass: "step-rail" }, [
            _c(
              "span",
              {
                staticClass: "step-number",
                class: { "step-number-done": _vm.steps.scope },
              },
              [_vm._v("1")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wizard-step-main" },
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _c("v-icon", { staticClass: "step-heading-icon" }, [
                    _vm._v("place"),
                  ]),
                  _vm._v("\n      Set the data scope\n      "),
                  _c("span", { staticClass: "step-status" }, [
                    _vm._v(
                      _vm._s(
                        _vm.steps.scope ? "Required · applied" : "Required"
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c("p", { staticClass: "wizard-description" }, [
                  _vm._v(
                    "Media determines which locations, analytes, and guidelines are available."
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "scope-fields" }, [
                  _c(
                    "section",
                    {
                      staticClass: "scope-field media-field",
                      attrs: { "aria-labelledby": "media-types-label" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "field-label",
                          attrs: { id: "media-types-label" },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("filter_list"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("1. Media type")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-select", {
                        ref: "mediaSelect",
                        staticClass: "media-select",
                        attrs: {
                          items: _vm.allMediaTypes,
                          disabled: !_vm.isInitialized || _vm.busy,
                          "menu-props": { maxHeight: 320 },
                          multiple: "",
                          chips: "",
                          "small-chips": "",
                          "deletable-chips": "",
                          outlined: "",
                          "hide-details": "",
                          placeholder: "Select one or more media types",
                          "prepend-inner-icon": "filter_list",
                          "aria-labelledby": "media-types-label",
                        },
                        on: { change: _vm.onMediaTypesChange },
                        scopedSlots: _vm._u([
                          {
                            key: "no-data",
                            fn: function () {
                              return [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.isInitialized
                                                ? "No media types are available."
                                                : "Loading media types…"
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.draft.mediaTypes,
                          callback: function ($$v) {
                            _vm.$set(_vm.draft, "mediaTypes", $$v)
                          },
                          expression: "draft.mediaTypes",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-hint" }, [
                        _vm._v(
                          "Select one or more media types first; available locations depend on this choice."
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    {
                      staticClass: "scope-field location-field",
                      attrs: { "aria-labelledby": "locations-label" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "field-label",
                          attrs: { id: "locations-label" },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("place"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("2. Locations")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "location-box",
                          class: {
                            "location-box-disabled":
                              !_vm.draft.mediaTypes.length,
                          },
                        },
                        [
                          _c("span", { staticClass: "selected-count" }, [
                            _vm._v(
                              _vm._s(
                                _vm.draft.stationIds.length +
                                  _vm.missingStationIds.length
                              ) + " selected"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                outlined: "",
                                small: "",
                                color: "info",
                                disabled:
                                  !_vm.draft.mediaTypes.length || _vm.busy,
                                "aria-expanded": _vm.locationEditorOpen,
                                "aria-controls": "location-editor",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.locationEditorOpen =
                                    !_vm.locationEditorOpen
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "", small: "" } }, [
                                _vm._v("edit_location"),
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.locationEditorOpen
                                      ? "Hide locations"
                                      : "Choose locations"
                                  ) +
                                  "\n            "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.locationEditorOpen
                        ? _c(
                            "div",
                            {
                              staticClass: "location-editor",
                              attrs: { id: "location-editor" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "search-tools" },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      disabled:
                                        !_vm.draft.mediaTypes.length ||
                                        _vm.busy,
                                      label: "Search locations",
                                      "prepend-inner-icon": "search",
                                      clearable: "",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.locationSearch,
                                      callback: function ($$v) {
                                        _vm.locationSearch = $$v
                                      },
                                      expression: "locationSearch",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "list-controls" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "tool-text-btn",
                                          attrs: {
                                            flat: "",
                                            disabled:
                                              _vm.busy ||
                                              !_vm.matchingLocations.length,
                                          },
                                          on: {
                                            click: _vm.selectMatchingLocations,
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "", small: "" } },
                                            [_vm._v("playlist_add_check")]
                                          ),
                                          _vm._v(
                                            "\n                  Select matching\n                "
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "tool-text-btn",
                                          attrs: {
                                            flat: "",
                                            disabled:
                                              _vm.busy ||
                                              !_vm.draft.stationIds.length,
                                          },
                                          on: { click: _vm.clearLocations },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "", small: "" } },
                                            [_vm._v("delete_outline")]
                                          ),
                                          _vm._v(
                                            "\n                  Clear selection\n                "
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "list-result-count" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.filteredLocationItems.length
                                            ) + " locations"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "selection-count" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.draft.stationIds.length
                                            ) + " selected"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.filteredLocationItems.length
                                ? _c(
                                    "div",
                                    { staticClass: "location-options" },
                                    _vm._l(
                                      _vm.filteredLocationItems,
                                      function (location) {
                                        return _c("v-checkbox", {
                                          key: location.id,
                                          staticClass: "location-checkbox",
                                          attrs: {
                                            "input-value":
                                              _vm.draft.stationIds.includes(
                                                location.id
                                              ),
                                            label: location.name,
                                            disabled:
                                              _vm.busy ||
                                              (!location.available &&
                                                !_vm.draft.stationIds.includes(
                                                  location.id
                                                )),
                                            "hide-details": "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleLocation(
                                                location.id,
                                                $event
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _c("div", { staticClass: "empty-state" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.draft.mediaTypes.length
                                            ? "No locations match this search."
                                            : "Select media types to see available locations."
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                            ]
                          )
                        : _c("div", { staticClass: "field-hint" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.draft.mediaTypes.length
                                    ? "Choose locations to include in this query."
                                    : "Select media types first to enable location selection."
                                ) +
                                "\n          "
                            ),
                          ]),
                      _vm._v(" "),
                      _vm.unavailableLocations.length
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                value: true,
                                type: "warning",
                                outline: "",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.unavailableLocations.length) +
                                  " selected location(s) do not match this media selection.\n            "
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.conciseNames(
                                      _vm.unavailableLocations.map(
                                        (location) => location.name
                                      ),
                                      3
                                    )
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.missingStationIds.length
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                value: true,
                                type: "warning",
                                outline: "",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.missingStationIds.length) +
                                  " saved location(s) are no longer available:\n            " +
                                  _vm._s(
                                    _vm.conciseNames(
                                      _vm.missingStationIds.map(
                                        (id) => `Location ${id}`
                                      ),
                                      3
                                    )
                                  ) +
                                  ".\n            "
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { outlined: "", small: "" },
                                  on: { click: _vm.discardMissingLocations },
                                },
                                [_vm._v("Remove unavailable locations")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.scopeError
                  ? _c(
                      "div",
                      {
                        staticClass: "error--text caption mt-2",
                        attrs: { role: "alert" },
                      },
                      [_vm._v(_vm._s(_vm.scopeError))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "step-summary",
                    attrs: { "aria-live": "polite" },
                  },
                  [
                    _c("v-icon", { attrs: { small: "" } }, [_vm._v("place")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.scopeSummary))]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "step-action" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "step-complete-btn",
                        class: { "step-complete-btn-active": _vm.steps.scope },
                        attrs: {
                          depressed: "",
                          loading: _vm.scopeBusy,
                          disabled: !_vm.isInitialized || _vm.busy,
                        },
                        on: { click: _vm.applyScope },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v(_vm._s(_vm.stepActionIcon(_vm.steps.scope))),
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.stepActionLabel(_vm.steps.scope)) +
                            "\n        "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "action-explanation" }, [
                      _vm._v(
                        "Confirms the scope and refreshes available analytes."
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "wizard-step",
          class: {
            "step-completed": _vm.steps.analytes,
            "step-locked": !_vm.steps.scope,
          },
          attrs: { id: "query-step-2", flat: "" },
        },
        [
          _c("div", { staticClass: "step-rail" }, [
            _c(
              "span",
              {
                staticClass: "step-number",
                class: { "step-number-done": _vm.steps.analytes },
              },
              [_vm._v("2")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wizard-step-main" },
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _c("v-icon", { staticClass: "step-heading-icon" }, [
                    _vm._v("science"),
                  ]),
                  _vm._v("\n      Choose analytes\n      "),
                  _c("span", { staticClass: "step-status" }, [
                    _vm._v(
                      _vm._s(
                        _vm.steps.analytes ? "Required · applied" : "Required"
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c("p", { staticClass: "wizard-description" }, [
                  _vm._v(
                    "Choose at least one analyte. Selections stay visible when they are unavailable for the current scope."
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "analyte-toolbar" }, [
                  _c("div", { staticClass: "selection-count" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.draft.analyteNames.length)),
                    ]),
                    _vm._v(" selected\n          "),
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("·"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class: {
                          "unavailable-summary": _vm.unavailableAnalytes.length,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.unavailableAnalytes.length
                                ? `${_vm.unavailableAnalytes.length} unavailable for this scope`
                                : "All selected analytes are available"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "analyte-picker" }, [
                  _c(
                    "section",
                    {
                      staticClass: "analyte-panel available-panel",
                      attrs: { "aria-labelledby": "available-analytes-title" },
                    },
                    [
                      _c("div", { staticClass: "analyte-panel-heading" }, [
                        _c("div", { staticClass: "analyte-panel-title" }, [
                          _c(
                            "strong",
                            { attrs: { id: "available-analytes-title" } },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("science"),
                              ]),
                              _vm._v("Available analytes"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.matchingAnalytes.length) + " analytes"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "analyte-panel-actions tool-actions" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "tool-text-btn",
                                attrs: {
                                  flat: "",
                                  disabled:
                                    _vm.busy ||
                                    !_vm.steps.scope ||
                                    !_vm.matchingAnalytes.length,
                                },
                                on: { click: _vm.selectMatchingAnalytes },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { left: "", small: "" } },
                                  [_vm._v("playlist_add_check")]
                                ),
                                _vm._v(
                                  "\n                Select matching\n              "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "tool-text-btn",
                                attrs: {
                                  flat: "",
                                  disabled:
                                    _vm.busy || !_vm.draft.analyteNames.length,
                                },
                                on: { click: _vm.clearAnalytes },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { left: "", small: "" } },
                                  [_vm._v("delete_outline")]
                                ),
                                _vm._v(
                                  "\n                Clear selection\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          disabled: _vm.busy || !_vm.steps.scope,
                          label: "Search by EnviroData analyte name",
                          "prepend-inner-icon": "search",
                          clearable: "",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.availableAnalyteSearch,
                          callback: function ($$v) {
                            _vm.availableAnalyteSearch = $$v
                          },
                          expression: "availableAnalyteSearch",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "analyte-list-scroll" },
                        [
                          _c("div", { staticClass: "list-heading" }, [
                            _c("span", [_vm._v("EnviroData analyte")]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Availability")]),
                          ]),
                          _vm._v(" "),
                          _vm.matchingAnalytes.length
                            ? _c(
                                "v-list",
                                {
                                  staticClass: "analyte-list",
                                  attrs: { dense: "" },
                                },
                                _vm._l(
                                  _vm.matchingAnalytes,
                                  function (analyte) {
                                    return _c(
                                      "v-list-tile",
                                      {
                                        key: analyte.AnalyteName,
                                        class: {
                                          "selected-analyte":
                                            _vm.isAnalyteSelected(
                                              analyte.AnalyteName
                                            ),
                                          "unavailable-row":
                                            analyte.available === false,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleAnalyte(
                                              analyte.AnalyteName
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-tile-action",
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                "input-value":
                                                  _vm.isAnalyteSelected(
                                                    analyte.AnalyteName
                                                  ),
                                                disabled:
                                                  _vm.busy || !_vm.steps.scope,
                                                color: "primary",
                                                "hide-details": "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.toggleAnalyte(
                                                    analyte.AnalyteName
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-content",
                                          [
                                            _c("v-list-tile-title", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.analyteLabel(analyte)
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-tile-sub-title",
                                              { staticClass: "analyte-meta" },
                                              [
                                                _vm.analyteDisplayName(analyte)
                                                  ? [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.analyteDisplayName(
                                                            analyte
                                                          )
                                                        ) + " · "
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.analyteDateRange(
                                                      analyte
                                                    )
                                                  ) + "\n                  "
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        analyte.available === false
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "unavailable-label",
                                              },
                                              [_vm._v("Unavailable")]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass: "available-label",
                                              },
                                              [_vm._v("Available")]
                                            ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            : _c("div", { staticClass: "empty-state" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.steps.scope
                                        ? "No available analytes match this search."
                                        : "Complete the data scope to load available analytes."
                                    ) +
                                    "\n            "
                                ),
                              ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    {
                      staticClass: "analyte-panel selected-panel",
                      attrs: { "aria-labelledby": "selected-analytes-title" },
                    },
                    [
                      _c("div", { staticClass: "analyte-panel-heading" }, [
                        _c("div", { staticClass: "analyte-panel-title" }, [
                          _c(
                            "strong",
                            { attrs: { id: "selected-analytes-title" } },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("check_circle"),
                              ]),
                              _vm._v("Selected analytes"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.draft.analyteNames.length) +
                                " selected"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.unavailableAnalytes.length
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "selection-count unavailable-summary",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.unavailableAnalytes.length) +
                                    " unavailable\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          disabled: _vm.busy,
                          label: "Find in selection",
                          "prepend-inner-icon": "search",
                          clearable: "",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.selectedAnalyteSearch,
                          callback: function ($$v) {
                            _vm.selectedAnalyteSearch = $$v
                          },
                          expression: "selectedAnalyteSearch",
                        },
                      }),
                      _vm._v(" "),
                      _vm.matchingSelectedAnalytes.length
                        ? _c(
                            "v-list",
                            {
                              staticClass: "analyte-list",
                              attrs: { dense: "" },
                            },
                            _vm._l(
                              _vm.matchingSelectedAnalytes,
                              function (analyte) {
                                return _c(
                                  "v-list-tile",
                                  { key: analyte.AnalyteName },
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v(
                                            _vm._s(_vm.analyteLabel(analyte))
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-sub-title",
                                          {
                                            class: _vm.isAnalyteAvailable(
                                              analyte.AnalyteName
                                            )
                                              ? "analyte-meta"
                                              : "analyte-meta unavailable-summary",
                                          },
                                          [
                                            _vm.analyteDisplayName(analyte)
                                              ? [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.analyteDisplayName(
                                                        analyte
                                                      )
                                                    ) + " · "
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _vm._v(
                                              _vm._s(
                                                _vm.analyteDateRange(analyte)
                                              ) +
                                                " ·\n                  " +
                                                _vm._s(
                                                  _vm.isAnalyteAvailable(
                                                    analyte.AnalyteName
                                                  )
                                                    ? "Available for this scope"
                                                    : "Unavailable for this scope"
                                                ) +
                                                "\n                "
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-action",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              "aria-label": `Remove ${_vm.analyteLabel(
                                                analyte
                                              )}`,
                                              disabled: _vm.busy,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeAnalyte(
                                                  analyte.AnalyteName
                                                )
                                              },
                                            },
                                          },
                                          [_c("v-icon", [_vm._v("close")])],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          )
                        : _c("div", { staticClass: "empty-state" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.draft.analyteNames.length
                                    ? "No selected analytes match this search."
                                    : "No analytes selected yet. Choose from the available list."
                                ) +
                                "\n          "
                            ),
                          ]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.analyteError
                  ? _c(
                      "div",
                      {
                        staticClass: "error--text caption mt-2",
                        attrs: { role: "alert" },
                      },
                      [_vm._v(_vm._s(_vm.analyteError))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "step-summary",
                    attrs: { "aria-live": "polite" },
                  },
                  [
                    _c("v-icon", { attrs: { small: "" } }, [_vm._v("science")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.analyteSummary))]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "step-action" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "step-complete-btn",
                        class: {
                          "step-complete-btn-active": _vm.steps.analytes,
                        },
                        attrs: {
                          depressed: "",
                          disabled: _vm.busy || !_vm.steps.scope,
                        },
                        on: { click: _vm.applyAnalytes },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v(
                            _vm._s(_vm.stepActionIcon(_vm.steps.analytes))
                          ),
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.stepActionLabel(_vm.steps.analytes)) +
                            "\n        "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "action-explanation" }, [
                      _vm._v("Confirms the required analyte selection."),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "wizard-step",
          class: {
            "step-completed": _vm.steps.dates,
            "step-locked": !_vm.steps.analytes,
          },
          attrs: { id: "query-step-3", flat: "" },
        },
        [
          _c("div", { staticClass: "step-rail" }, [
            _c(
              "span",
              {
                staticClass: "step-number",
                class: { "step-number-done": _vm.steps.dates },
              },
              [_vm._v("3")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wizard-step-main" },
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _c("v-icon", { staticClass: "step-heading-icon" }, [
                    _vm._v("date_range"),
                  ]),
                  _vm._v("\n      Choose the date range\n      "),
                  _c("span", { staticClass: "step-status" }, [
                    _vm._v(
                      _vm._s(
                        _vm.steps.dates ? "Required · applied" : "Required"
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c("p", { staticClass: "wizard-description" }, [
                  _vm._v(
                    "Analyte availability for this scope is now known, so the period you pick is limited to dates that hold data for the selected analytes."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "date-field" },
                  [
                    _c("DateRange", {
                      ref: "dateRange",
                      attrs: {
                        disabled:
                          !_vm.isInitialized || _vm.busy || !_vm.steps.analytes,
                        availableDateRange: _vm.availableDateRange,
                      },
                      on: { dateRange: _vm.onDateRangeChange },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.dateError
                  ? _c(
                      "div",
                      {
                        staticClass: "error--text caption mt-2",
                        attrs: { role: "alert" },
                      },
                      [_vm._v(_vm._s(_vm.dateError))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "step-summary",
                    attrs: { "aria-live": "polite" },
                  },
                  [
                    _c("v-icon", { attrs: { small: "" } }, [
                      _vm._v("date_range"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.dateSummary))]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "step-action" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "step-complete-btn",
                        class: { "step-complete-btn-active": _vm.steps.dates },
                        attrs: {
                          depressed: "",
                          disabled: _vm.busy || !_vm.steps.analytes,
                        },
                        on: { click: _vm.applyDateRange },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v(_vm._s(_vm.stepActionIcon(_vm.steps.dates))),
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.stepActionLabel(_vm.steps.dates)) +
                            "\n        "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "action-explanation" }, [
                      _vm._v("Confirms the reporting period for this extract."),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "wizard-step",
          class: {
            "step-completed": _vm.steps.guidelines,
            "step-locked": !_vm.steps.dates,
          },
          attrs: { id: "query-step-4", flat: "" },
        },
        [
          _c("div", { staticClass: "step-rail" }, [
            _c(
              "span",
              {
                staticClass: "step-number",
                class: {
                  "step-number-done": _vm.steps.guidelines,
                  "step-number-optional": !_vm.steps.guidelines,
                },
              },
              [_vm._v("4")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wizard-step-main" },
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _c("v-icon", { staticClass: "step-heading-icon" }, [
                    _vm._v("gavel"),
                  ]),
                  _vm._v("\n      Add guidelines\n      "),
                  _c(
                    "span",
                    { staticClass: "step-status optional-step-status" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.steps.guidelines
                            ? "Optional · applied"
                            : "Optional · decide"
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("p", { staticClass: "wizard-description" }, [
                    _vm._v(
                      "Guidelines are optional. Finish this step even if you do not need any."
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "guideline-toolbar" },
                    [
                      _c(
                        "v-btn-toggle",
                        {
                          staticClass: "guideline-tabs",
                          attrs: { mandatory: "" },
                          model: {
                            value: _vm.guidelineFilter,
                            callback: function ($$v) {
                              _vm.guidelineFilter = $$v
                            },
                            expression: "guidelineFilter",
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                flat: "",
                                small: "",
                                value: "available",
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "", small: "" } }, [
                                _vm._v("gavel"),
                              ]),
                              _vm._v("Available"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", value: "selected" },
                            },
                            [
                              _c("v-icon", { attrs: { left: "", small: "" } }, [
                                _vm._v("check_circle"),
                              ]),
                              _vm._v(
                                "Selected (" +
                                  _vm._s(_vm.draft.guidelineIds.length) +
                                  ")"
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          disabled: _vm.busy || !_vm.steps.dates,
                          label: "Search guidelines",
                          "prepend-inner-icon": "search",
                          clearable: "",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.guidelineSearch,
                          callback: function ($$v) {
                            _vm.guidelineSearch = $$v
                          },
                          expression: "guidelineSearch",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            outlined: "",
                            small: "",
                            disabled:
                              _vm.busy || !_vm.draft.guidelineIds.length,
                          },
                          on: { click: _vm.clearGuidelines },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("clear_all"),
                          ]),
                          _vm._v("\n          Clear selection\n        "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "guideline-limit" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.draft.guidelineIds.length)),
                        ]),
                        _vm._v(" / " + _vm._s(_vm.maxGuidelines) + " selected"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.draft.guidelineIds.length >= _vm.maxGuidelines
                    ? _c("div", { staticClass: "warning--text caption mt-2" }, [
                        _vm._v(
                          "\n        Maximum of " +
                            _vm._s(_vm.maxGuidelines) +
                            " guidelines selected.\n      "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.missingGuidelineIds.length
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mt-3",
                          attrs: { value: true, type: "warning", outline: "" },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.missingGuidelineIds.length) +
                              " saved guideline(s) are no longer available.\n        "
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { outlined: "", small: "" },
                              on: { click: _vm.discardMissingGuidelines },
                            },
                            [_vm._v("Remove unavailable saved guidelines")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.guidelinesByCategory.length
                    ? _c(
                        "div",
                        { staticClass: "guideline-list" },
                        _vm._l(_vm.guidelinesByCategory, function (category) {
                          return _c(
                            "div",
                            { key: category.name },
                            [
                              _c(
                                "v-list-tile",
                                { staticClass: "guideline-category" },
                                [
                                  _vm.guidelineFilter === "available"
                                    ? _c(
                                        "v-list-tile-action",
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              "input-value":
                                                category.allSelected,
                                              indeterminate:
                                                category.partiallySelected,
                                              disabled:
                                                _vm.busy ||
                                                !_vm.steps.dates ||
                                                (!category.canSelect &&
                                                  !category.allSelected),
                                              color: "primary",
                                              "hide-details": "",
                                              "aria-label": `Select all ${category.name} guidelines`,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.toggleGuidelineCategory(
                                                  category
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c(
                                        "v-list-tile-title",
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-2",
                                              attrs: { small: "" },
                                            },
                                            [_vm._v("gavel")]
                                          ),
                                          _vm._v(_vm._s(category.name)),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-action-text", [
                                    _vm._v(_vm._s(category.guidelines.length)),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(category.guidelines, function (guideline) {
                                return _c(
                                  "v-list-tile",
                                  {
                                    key: guideline.Id,
                                    staticClass: "guideline-row",
                                  },
                                  [
                                    _c(
                                      "v-list-tile-action",
                                      [
                                        _c("v-checkbox", {
                                          attrs: {
                                            "input-value":
                                              _vm.isGuidelineSelected(
                                                guideline.Id
                                              ),
                                            disabled:
                                              _vm.busy ||
                                              !_vm.steps.dates ||
                                              (!_vm.isGuidelineSelected(
                                                guideline.Id
                                              ) &&
                                                _vm.draft.guidelineIds.length >=
                                                  _vm.maxGuidelines),
                                            color: "primary",
                                            "hide-details": "",
                                            "aria-label": `${
                                              _vm.isGuidelineSelected(
                                                guideline.Id
                                              )
                                                ? "Remove"
                                                : "Add"
                                            } ${guideline.GuidelineName}`,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleGuideline(
                                                guideline.Id
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v(
                                            _vm._s(guideline.GuidelineName)
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("v-list-tile-sub-title", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                guideline.GuidelineLongName
                                              ) +
                                              "\n                "
                                          ),
                                          !_vm.isGuidelineAvailable(
                                            guideline.Id
                                          )
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "warning--text",
                                                },
                                                [
                                                  _vm._v(
                                                    " · Unavailable for this scope"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          )
                        }),
                        0
                      )
                    : _c("div", { staticClass: "empty-state" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.guidelineFilter === "selected"
                                ? "No guidelines selected."
                                : "No guidelines are available for this scope."
                            ) +
                            "\n      "
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.guidelineError
                    ? _c(
                        "div",
                        {
                          staticClass: "error--text caption mt-2",
                          attrs: { role: "alert" },
                        },
                        [_vm._v(_vm._s(_vm.guidelineError))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "step-summary",
                      attrs: { "aria-live": "polite" },
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [_vm._v("gavel")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.guidelineSummary))]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "step-action" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "step-complete-btn",
                          class: {
                            "step-complete-btn-active": _vm.steps.guidelines,
                          },
                          attrs: {
                            depressed: "",
                            disabled: _vm.busy || !_vm.steps.dates,
                          },
                          on: { click: _vm.applyGuidelines },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v(
                              _vm._s(_vm.stepActionIcon(_vm.steps.guidelines))
                            ),
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.stepActionLabel(_vm.steps.guidelines)
                              ) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "action-explanation" }, [
                        _vm._v("Choose guidelines or continue without them."),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "wizard-step",
          class: {
            "step-completed": _vm.canSubmit,
            "step-locked": !_vm.steps.guidelines,
          },
          attrs: { id: "query-step-5", flat: "" },
        },
        [
          _c("div", { staticClass: "step-rail" }, [
            _c(
              "span",
              {
                staticClass: "step-number",
                class: { "step-number-done": _vm.canSubmit },
              },
              [_vm._v("5")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wizard-step-main" },
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _c("v-icon", { staticClass: "step-heading-icon" }, [
                    _vm._v("assignment"),
                  ]),
                  _vm._v("\n      Review your selection\n      "),
                  _c(
                    "span",
                    {
                      staticClass: "step-status",
                      class: { "optional-step-status": !_vm.canSubmit },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.canSubmit ? "Ready" : "Waiting for Step 4")
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("div", { staticClass: "review-grid" }, [
                    _c("div", { staticClass: "review-item" }, [
                      _c("span", { staticClass: "review-label" }, [
                        _vm._v("Media type"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "review-value" }, [
                        _vm._v(
                          _vm._s(_vm.conciseNames(_vm.draft.mediaTypes, 4))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-item" }, [
                      _c("span", { staticClass: "review-label" }, [
                        _vm._v("Locations"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "review-value" }, [
                        _vm._v(_vm._s(_vm.locationSummary)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-item" }, [
                      _c("span", { staticClass: "review-label" }, [
                        _vm._v("Date range"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "review-value" }, [
                        _vm._v(_vm._s(_vm.dateRangeSummary)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-item" }, [
                      _c("span", { staticClass: "review-label" }, [
                        _vm._v("Selected analytes"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "review-value" }, [
                        _vm._v(
                          _vm._s(_vm.draft.analyteNames.length) +
                            " selected · " +
                            _vm._s(_vm.unavailableAnalytes.length) +
                            " unavailable"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-item" }, [
                      _c("span", { staticClass: "review-label" }, [
                        _vm._v("Guidelines"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "review-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.draft.guidelineIds.length
                              ? `${_vm.draft.guidelineIds.length} selected · ${_vm.missingGuidelineIds.length} unavailable`
                              : "None · optional"
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-item" }, [
                      _c("span", { staticClass: "review-label" }, [
                        _vm._v("Filter status"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "review-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.canSubmit ? "Applied" : "Changes not applied"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "health-message",
                      class: {
                        good: _vm.canSubmit && !_vm.unavailableAnalytes.length,
                      },
                    },
                    [
                      _c("span", { staticClass: "health-dot" }, [
                        _vm._v(
                          _vm._s(
                            _vm.canSubmit && !_vm.unavailableAnalytes.length
                              ? "✓"
                              : "!"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.reviewHealthMessage))]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider", { staticClass: "my-3" }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "subheading font-weight-medium" }, [
                    _vm._v("Report options"),
                  ]),
                  _vm._v(" "),
                  _c("ReportParams", {
                    ref: "reportParams",
                    attrs: { disabled: _vm.busy, selection: _vm.selection },
                    on: { "update:reportOptions": _vm.onReportOptions },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "review-actions" }, [
                    _c(
                      "div",
                      { staticClass: "review-actions-left" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              outlined: "",
                              disabled: _vm.busy || !_vm.hasDraftChanges,
                            },
                            on: { click: _vm.resetChanges },
                          },
                          [
                            _c("v-icon", { attrs: { left: "", small: "" } }, [
                              _vm._v("refresh"),
                            ]),
                            _vm._v("\n            Reset changes\n          "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "review-note" }, [
                          _vm._v(
                            _vm._s(
                              _vm.hasDraftChanges
                                ? "Changes are not applied yet."
                                : "Selection is up to date."
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "review-actions-right" },
                      [
                        _c("AsyncDownload", {
                          attrs: {
                            disabled: !_vm.canSubmit,
                            selection: _vm.selection,
                            reportOptions: _vm.reportOptions,
                          },
                          on: { loading: _vm.onDownloadLoading },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }